// extracted by mini-css-extract-plugin
module.exports = {"variant":"styles_variant__gifC4","variantActive":"styles_variantActive__cyxVq","variantImg":"styles_variantImg__0dkxC","variantColor":"styles_variantColor__03fXz"};